const config = {
  apiUrl:
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_ENVIRONMENT === 'development'
        ? 'https://dev.crossroadschurch.ph'
        : 'https://www.crossroadschurch.ph'
      : process.env.REACT_APP_API_URL || 'http://localhost:5000',
  graphqlUrl:
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_ENVIRONMENT === 'development'
        ? 'https://dev.crossroadschurch.ph/graphql'
        : 'https://www.crossroadschurch.ph/graphql'
      : process.env.REACT_APP_GRAPHQL_URL || 'http://localhost:5000/graphql',
  webAppUrl:
    process.env.NODE_ENV === 'production'
      ? process.env.REACT_APP_ENVIRONMENT === 'development'
        ? 'https://dev.crossroadschurch.ph/webui'
        : 'https://www.crossroadschurch.ph/webui'
      : process.env.REACT_APP_WEB_APP_URL || 'http://localhost:3000/webui',
};

export default config;
